import axiosInstance from '../utility/axios';
import { startLoading } from "./sign-up";
import { history } from "../routers/AppRouter";
import { signOut } from "./sign-in";

export const showError = (errorMessage) => ({
  type: 'SHOW_ERROR',
  errorMessage
});

export const startGetProfile = () => ({
  type: 'START_GET_PROFILE',
});

export const getProfileSuccess = (profile) => ({
  type: 'GET_PROFILE_SUCCESS',
  profile
});

export const getProfile = (userId) => {

  return (dispatch) => {
    dispatch(startGetProfile());

    const url = userId != null ? `profile/${userId}` : 'profile';

    axiosInstance.get(url)
      .then((response) => {

        if (response.data.profile === false) {
          // no profile yet
        } else {
          dispatch(getProfileSuccess(response.data));
        }
      })
      .catch((error) => {
        if (error.response?.status === 401) {
          setTimeout(() => {
            dispatch(showError('Token expired, please login again.'));
            dispatch(signOut());
          }, 3000);
        } else {
          dispatch(showError(error.response?.data?.message));
          console.log(error);
        }
      });
  }
};

export const startCreateProfile = () => ({
  type: 'START_CREATE_PROFILE'
});

export const createProfileSuccess = (profileInfo) => ({
  type: 'CREATE_PROFILE_SUCCESS',
  profileInfo
});

export const createProfile = (profileInfo) => {
  return (dispatch) => {
    dispatch(startCreateProfile());
    axiosInstance.post('profile', profileInfo)
      .then((response) => {
        dispatch(createProfileSuccess(response.data));
        console.log('profile created!');
      })
      .catch((error) => {
        dispatch(showError());
        console.log(error);
      });
  }
};

export const startProfileUpdate = () => ({
  type: 'START_PROFILE_UPDATE',
});

export const updateProfiledSuccess = (profileInfo) => ({
  type: 'PROFILE_UPDATE_SUCCESS',
  profileInfo
});

export const updateProfile = (profileInfo, userId) => {
  return (dispatch) => {
    dispatch(startProfileUpdate());

    const url = userId ? `profile/${userId}` : 'profile';

    axiosInstance.put(url, profileInfo)
      .then((response) => {
        dispatch(updateProfiledSuccess(profileInfo));
      })
      .catch((error) => {
        dispatch(showError(error.response?.data?.message));
        console.log(error);
      });
  }
};

